var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nrk"},[_c('Carousel',{staticClass:"pc-display",attrs:{"data":_vm.Honor}}),_c('CarouselMobile',{staticClass:"mobile-display",attrs:{"data":_vm.Honor}})],1),_c('Timeline',{attrs:{"data":_vm.Honorother,"mane":_vm.nama}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }